import Moment from "moment/moment";
import ViewController from "core/views/view.controller";
import {BookingsFilter} from "../../services/bookings.service";
import DashboardActions from "./dashboard.actions.html";

export default class DashCtrl extends ViewController {
    static $inject = ['$scope', '$ionicPopover', 'Bookings', 'Workloads', 'settings'];

    constructor() {
        super(...arguments);
        this.viewTitle = null;
        this.viewMode = 'day';
        this.actionsPopover = null;
        this.date = null;
        this.bookings = [];
        this.workload = null;
    }

    $onViewBeforeEnter() {
        if (!this.date) {
            this.onDateSelected(Moment());
        } else {
            this.loadBookings();
        }
    }

    loadBookings() {
        let bookingsFilter = new BookingsFilter();
        bookingsFilter.dateStart = Moment(this.date).startOf(this.viewMode);
        bookingsFilter.dateEnd = Moment(this.date).endOf(this.viewMode);
        bookingsFilter.state = null;

        let branch = this.settings.branch;
        if (branch && branch.id) {
            bookingsFilter.branchId = branch.id;
        }

        this.Bookings.find(bookingsFilter).then((result) => {
            this.bookings = result.data;
        });

        this.Workloads.inDateRange(bookingsFilter.dateStart, bookingsFilter.dateEnd, this.viewMode, true)
            .then(workloads => {
                if (workloads.length > 0) {
                    this.workload = workloads[0];

                } else {
                    this.workload = null;
                }
            });
    }

    prevDate() {
        this.$scope.$broadcast('weekDateSelection.prevDate');
    }

    nextDate() {
        this.$scope.$broadcast('weekDateSelection.nextDate');
    }

    setCurrentDate() {
        this.onDateSelected(Moment());
    };

    onDateSelected(date) {
        this.date = Moment(date);

        this.updateViewTitle(date);
        this.loadBookings();
    }

    onRangeSelected(dates) {
        this.updateViewTitle(dates[2]);
    }

    updateViewTitle(date) {
        date = Moment(date);

        if (this.viewMode == 'day') {
            this.viewTitle = date.format('MMMM, [KW] WW');

        } else if (this.viewMode == 'week') {
            this.viewTitle = date.format('MMMM');

        } else if (this.viewMode == 'month') {
            this.viewTitle = date.format('YYYY');
        }
    }

    showActions($event) {
        if (!this.actionsPopover) {
            this.actionsPopover = this.$ionicPopover.fromTemplate(DashboardActions, {
                scope: this.$scope
            });
        }

        this.actionsPopover.show($event);
    }

    actionSetViewMode(viewMode) {
        this.actionsPopover.hide();
        this.viewMode = viewMode;
        this.loadBookings();
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/views/dashboard/dashboard.controller.js